/** Basics */
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'

import VueLodash from 'vue-lodash'
import lodash from 'lodash' // options is optional

/** Components  */
import vueSmoothScroll from 'vue-smoothscroll'

import VueImageLoader from '@kevindesousa/vue-image-loader'

import KTabs from '@kevindesousa/vue-k-tabs'

import KDropdown from '@kevindesousa/vue-k-dropdown'

import Vuebar from 'vuebar'

import VoerroTagsInput from '@voerro/vue-tagsinput'
// To remove
import vOutsideEvents from 'vue-outside-events'

import VueInputAutowidth from 'vue-input-autowidth'

import 'vue-swatches/dist/vue-swatches.min.css'

import VueI18n from 'vue-i18n'
import messages from './translations/lang'

import moment from 'moment-timezone'
Vue.use(Vuex)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(vueSmoothScroll)
Vue.use(VueImageLoader)
Vue.use(KTabs)
Vue.use(KDropdown)
Vue.use(Vuebar)
Vue.component('tags', VoerroTagsInput)
Vue.use(vOutsideEvents)

Vue.use(VueInputAutowidth)

Vue.prototype.moment = moment

// internal
require('@/plugins/components')
require('@/plugins/layouts')
require('@/plugins/mixins')

// utilities
require('@/plugins/utilities/axios')
require('@/plugins/utilities/vee-validate')

// ui
require('@/plugins/ui/element-ui')
require('@/plugins/ui/font-awesome')
require('@/plugins/ui/flag-icon')
require('@/plugins/ui/styles')

Vue.config.productionTip = true

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages,
  missing: (locale, key, vm) => {
    if (key.substring(0, 4) === 'api.') {
      if (key.substring(key.length - 6) === '.title') {
        return vm.$t('api.default.title')
      } else {
        return vm.$t('api.default.message')
      }
    }
  }
})

// Load filters
require('./filters/date')
require('./filters/lang')

window['vm'] = new Vue({
  store: store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js